<style scoped>
.simple-size {
    color: #ccc;
    font-size: 12px;
    height: 20px;
    padding: 0;
    margin: 0;
}
</style>

<template>
<div>
    <Modal
        :value="showModel"
        :title="title"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose">
        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">
             <Tabs type="card" v-model="tabIndex">
            <TabPane label="基本信息" name="1" value="1">
            <FormItem label="文章标题:" prop="title">
                <Input type="text" v-model="formData.title"></Input>
            </FormItem>
            <FormItem label="缩略图：" prop="thumb">
                <ImgUpload ref="upImg" :action="actionUrlThumb" :hasUpload="hasUpload" :num="num" @setThumbUrl="setThumbUrlthumb"></ImgUpload>
                <span class="simple-size">大小： 200 * 200</span>
            </FormItem>
            <FormItem label="简单描述:" prop="des">
                <Input type="text" v-model="formData.des"></Input>
            </FormItem>
            <FormItem label="关键词:" prop="keywords">
                <Input type="text" v-model="formData.keywords" placeholder="多个使用英文逗号分割，如：关键词1,关键词2,关键词3"></Input>
            </FormItem>
            <FormItem label="附件:" prop="download_url">
                <FileUpload ref="upFile" :action="actionUrlFile" :hasUpload="hasUploadFile" :num="num" @setThumbUrl="setFileUrlthumb"></FileUpload>
                <span class="simple-size">大小：5MB</span>
            </FormItem>
            <!-- <FormItem label="所属分类" prop="cate_id" >
                <SearchSelect :isMultiple='2' ref="apply_val" :url="searchCateUrl" labelName='cate_name' valName='id' keyword="keyword" @setSelected="setSelectVal($event,'cate_id')"></SearchSelect>
            </FormItem> -->
            <FormItem label="推荐：" prop="rem">
                <RadioGroup v-model="formData.rem">
                    <Radio label="1">
                        <span>是</span>
                    </Radio>
                    <Radio label="2">
                        <span>否</span>
                    </Radio>
                </RadioGroup>
            </FormItem>
            
            <FormItem label="状态：" prop="status">
                <RadioGroup v-model="formData.status">
                    <Radio label="1">
                        <span>显示</span>
                    </Radio>
                    <Radio label="2">
                        <span>隐藏</span>
                    </Radio>
                </RadioGroup>
            </FormItem>
            <FormItem label="类型：" prop="is_topic">
                <RadioGroup v-model="formData.is_topic">
                    <Radio label="1">
                        <span>活动</span>
                    </Radio>
                    <Radio label="2">
                        <span>课程</span>
                    </Radio>
                </RadioGroup>
            </FormItem>
            <FormItem label="课程链接:" prop="sort" v-if="formData.is_topic==2">
                <Input type="text"  v-model="formData.video_url"></Input>
            </FormItem>
             <FormItem label="排序:" prop="sort">
                <Input type="text"  v-model="formData.sort"></Input>
            </FormItem>
            <FormItem label="时间范围" prop="sort" class="ivu-form-item-required">
                <DatePicker @on-change="setSelected($event,'timeArea')"  type="daterange"  placement="bottom" v-model="formData.timeArea"  placeholder="请选择时间范围" style="width: 200px"></DatePicker>
            </FormItem>
            <FormItem>
                <Button :disabled="disabled" type="primary" @click="subData('formData')">确定</Button>
            </FormItem>
            </TabPane>
            <TabPane label="图文详情" name="2" value="2">
            <FormItem label="详情:" prop="detail">
                <vue-neditor-wrap v-model="formData.detail" :config="editorConfig" :destroy="false"></vue-neditor-wrap>
            </FormItem>

            <FormItem>
                <Button :disabled="disabled" type="primary" @click="subData('formData')">确定</Button>
            </FormItem>
            </TabPane>
            
            </Tabs>
        </Form>

    </Modal>
</div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import SearchSelect from '../common/selectList';
import VueNeditorWrap from 'vue-neditor-wrap';
import FileUpload from "../common/uploadFile";
import ImgUpload from "../common/upload";
    export default {
        props: {
            showModel: Boolean,
            fn:Function,
            type:Number,
            editFormData:Object
        },
        name: "Model3",
        data() {
            return {
                tabIndex:"1",
                disabled: false,//禁用确定按钮
                title: '',//弹框标题
                searchCateUrl: this.config.urlArray.searchArtCate,
                editorConfig: {
                    // 如果需要上传功能,找后端小伙伴要服务器接口地址
                    serverUrl: this.config.urlArray.articleUploadThumb,
                    // 你的UEditor资源存放的路径,相对于打包后的index.html
                    UEDITOR_HOME_URL: '/neditor/',
                    // 编辑器不自动被内容撑高
                    autoHeightEnabled: false,
                    // 初始容器高度
                    initialFrameHeight: 600,
                    // 初始容器宽度
                    initialFrameWidth: '100%',
                    // 关闭自动保存
                    enableAutoSave: false
                },
                formData: {//表单数据
                    title: '',
                    sort: '100',
                    thumb: '',
                    cate_id: '',
                    des:'',
                    keywords:'',
                    download_url:'',
                    rem: '2',
                    status: '1',
                    detail:'',
                    timeArea:['',''],
                    start_time:'',
                    end_time:'',
                    is_topic:'1',
                    video_url:''
                },
                actionUrlThumb: this.config.urlArray.commonUploadImage, //上传图片接口
                actionUrlFile: this.config.urlArray.articleUploadFile, //上传附件接口
                num: 1, //图片上传数量
                hasUpload: [], //已上传图片
                hasUploadFile: [], //已上传附件
                ruleCustom: {//验证
                    title: [
                        {required: true, message: '文章标题不能为空', trigger: 'blur' },
                    ],
                    // cate_id: [
                    //     {required: true, message: '分类必须选择', trigger: 'blur' },
                    // ],
                    des: [
                        {required: true, message: '简单描述不能为空', trigger: 'blur' },
                    ],
                    keywords: [
                        {required: true, message: '关键词不能为空', trigger: 'blur' },
                    ],
                    status: [
                        {required: true, message: '状态不能为空', trigger: 'change' },
                    ],
                    thumb: [
                        { required: true, message: "缩略图片必须上传", trigger: "blur" },
                    ],
                    detail: [
                        { required: true, message: "详情必须填写", trigger: "blur" },
                    ],
                    sort: [
                        {required: true, message: '排序不能为空', trigger: 'blur' },
                        { type: 'string', pattern: /^[0-9]\d*$/i, message:'排序必须为不小于零的整数', trigger:'blur'},
                    ],
                },
            }
        },
        components: {
            SearchSelect,
            ImgUpload,
            VueNeditorWrap,
            FileUpload
        },
        methods: {
          setSelected(e) {
            this.formData.start_time = e[0]
            this.formData.end_time = e[1]
          },
            setThumbUrlthumb(url) { //获取图片上传后的路径   商品封面图
                this.formData.thumb = url;
            },
            setFileUrlthumb(url) { //获取附件上传后的路径
                this.formData.download_url = url;
            },
            openOrClose(value) {
                if(value === true) {
                    if(this.type == 2){//编辑表单时，给表单赋值
                        this.formData.title = this.editFormData.title.toString();
                        this.formData.sort = this.editFormData.sort.toString();
                        this.formData.des = this.editFormData.des;
                        this.formData.timeArea = [this.editFormData.start_time,this.editFormData.end_time];
                        this.formData.detail = this.editFormData.detail;
                        this.formData.rem = this.editFormData.rem.toString();
                        this.formData.status = this.editFormData.status.toString();
                        this.formData.cate_id = this.editFormData.cate_id.toString();
                        this.formData.keywords = this.editFormData.keywords.toString();
                        this.formData.is_topic = this.editFormData.is_topic.toString();
                        this.formData.video_url = this.editFormData.video_url;
                        this.formData.download_url = this.editFormData.download_url;
                        this.formData.thumb = this.editFormData.thumb
                        let hasUpload = [{
                            status:'finished',
                            response:{data:{path:this.editFormData.thumb}}
                        }]
                        this.$refs.upImg.setHasUpload(hasUpload)//为上传组件付默认值
                        let hasUploadFile = [{
                            status:'finished',
                            response:{data: this.editFormData.download_url}
                        }]
                        this.$refs.upFile.setHasUpload(hasUploadFile)//为上传组件付默认值

                        // setTimeout(() => {
                        //     this.$refs.apply_val.setDefVal(Number(this.formData.cate_id));
                        // }, 500);

                    }
                    this.title = this.type == 1?'添加文章':'编辑文章'
                } else { //关闭弹框后要做的处理

                    this.$refs.upFile.clearImg()//清除已上传的图片
                    this.$refs.upImg.clearImg()//清除已上传的图片
                    // this.$refs.apply_val.clearVal();
                    this.resetForm();//重置表单
                }
            },
            subData(name) {//提交表单
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.disabled = true;

                        if (this.type == 2) {
                            this.formData.id = this.editFormData.id
                        }
                        this.formData.start_time = this.formData.timeArea[0]
                        this.formData.end_time = this.formData.timeArea[1]

                        this.axios.post(this.config.urlArray.articleStore, this.formData).then((result) => {
                            common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                                this.resetForm();//重置表单
                                this.fn()
                            },()=>{this.disabled = false; })

                        }).catch((err) => {
                            common.msg('error','提交失败',()=>{this.disabled = false;})
                        });

                    }
                })
            },
            setSelectVal(data,key){
                this.formData[key] = data.toString()
            },
            cancel() {//对话框关闭
                this.$emit('update:showModel',false);
            },
            resetForm() {//重置表单
            this.tabIndex = '1'
                this.$refs.upFile.clearImg()//清除已上传的图片
                this.$refs.upImg.clearImg()//清除已上传的图片
                // this.$refs.apply_val.clearVal();
                this.$refs.formData.resetFields();//重置表单
                this.disabled = false;//恢复提交按钮为激活状态
                if(this.type == 2){
                    delete this.formData.id
                }
            }
        }
    }
</script>
